var HtmlBuilder = new (class HtmlBuilder extends AbstractModule {

  constructor() {
    super("HtmlBuilder");

    /**
     * @type {"HOMEPAGE"|"EDITOR"}
     */
    this.buildType = "HOMEPAGE"
    this.layoutMandatory = ["type"]
    // (/!\ Remember to disable verbose mode in production environment /!\)
    this.verbose = false // Debugging may be tough, enable this to access step-by-step very talkative build log

    this.cardBlocks = []
    this.blockIdentifiers = {}
    this.postBuildIdQueue = []
    this.invalidBuild = false
    this.invalidationMessage = "No error detected. If you see this error, it must be a mistake and you may want to ignore it."
  }

  _initAfterGuest() {
    this.data = this._loadDataMap()

    if (this.verbose) {
      this.app.toggleDebug(true)
    }
  }

  // This data mapping here allow us to change GULP variable names without having to change JSONs
  // Map your variables here instead of injecting them directly through JSON
  // Note: `settings` is dedicated to blocks slot settings auto-injection please don't override it
  _loadDataMap() {
    return({
      widget: {
        window_color: this.app._window_color,
        title_color: this.app._title_color,
        status_page_url: this.app._status_page_url,
        support_img: this.app._support_img
      },
      svg: {
        helpcenter_search: Svg.hcSearch()
      }
    });
  }

  _loadEmptyBlock(slotId) {
    const emptyBlock = document.createElement("div");

    emptyBlock.setAttribute("slot-id", slotId);
    emptyBlock.className += "template-editor-slot";

    return ([emptyBlock]);
  }

  // Builder Error Manager
  _invalidate(error_message) {
    this.invalidBuild = true;
    this.invalidationMessage = error_message;
  }

  // Verbose logger
  _logger(step, stepData = {}) {
    if (!this.verbose) {
      return;
    }

    let modules = {
      "BUILD_START": true,
      "BUILD_CARD_BEGIN": true,
      "BUILD_LAYOUT_DEPTH": true,
      "BUILD_DATA_INJECTION": true,
      "BUILD_PARENT_CHECK": true,
      "BUILD_DEFINE_TYPE": true,
      "BUILD_DETECTED": true,
      "BUILD_END": true
    }

    let processedStep = modules[step] ? step : "IGNORED";

    switch(processedStep) {
      case "BUILD_START":
        this._print("Build start.");
        this._print(`Build type: ${stepData.types ? "Block > " + stepData.types.blockLabel : "Layout." }`);
        this._printObject("settings", stepData.settings);
        break;

      case "BUILD_CARD_BEGIN":
        this._print("Building element...");
        break;

      case "BUILD_LAYOUT_DEPTH":
        this._print("Building new layout depth...");
        this._printObject("layout", stepData.layout);
        this._printObject("settings", stepData.settings);
        break;

      case "BUILD_DATA_INJECTION":
        this._print("Data injection processing...");
        this._printObject("field", stepData.field);
        this._printObject("object", stepData.object);

      case "BUILD_PARENT_CHECK":
        this._print("Parent given as a build argument: see below.");
        this._printObject("parent", stepData.parent);
        break;

      case "BUILD_DEFINE_TYPE":
        this._print(`Original raw type: ${stepData.type}`);
        this._printObject("definedType", stepData.definedType);
        this._print(`Defined type: ${stepData.layoutType}`);
        this._print(`Defined action type: ${stepData.layoutActionType}`);
        break;

      case "BUILD_DETECTED":
        this._print(`Detected: ${stepData.detected}`);

      case "BUILD_END":
        this._print(`${this.invalidBuild ? "Build failed." : "Build done."}`)

        if (this.invalidBuild) {
          this._print("See console.error stream for more details");
        } else {
          this._print("Build result: ===== START =====");
          Utils.log(stepData.domElement ? stepData.domElement : "Unexpected scenario happened. domElement missing and no error log available.\nUncaught error, advanced in-depth checking needed.")
          this._print("Build result: ===== END =====");
          this._separator();
        }
        break;

      case "IGNORED":
        break;

      default:
        this._print("Error: Undefined logger step.");
        break;
    }
  }

  _print(message) {
    Utils.log("[HtmlBuilder] - " + message);
  }

  _separator() {
    Utils.log("-------------------------------------");
  }

  _printObject(label, object) {
    this._print(`Build ${label}: ${object ? "===== BEGIN =====" : "None."}`)

    if (object) {
      Utils.log(object);
      this._print(`Build ${label}: ===== END =====`)
    }
  }

  loadCardBlocks(cardBlocks) {
    this.cardBlocks = cardBlocks;
  }

  reset() {
    this.cardBlocks = [];
    this.currentId = 0;
    this.buildType = "HOMEPAGE";
    this.postBuildIdQueue = []
  }

  getPostBuildQueue() {
    return(this.postBuildIdQueue);
  }

  setBuildType(type) {
    const availableTypes = ["HOMEPAGE", "EDITOR"];

    this.buildType = availableTypes.includes(type) ? type : this.buildType;
  }

  generateBlockId(blockType) {
    if (!this.blockIdentifiers[blockType]) {
      this.blockIdentifiers[blockType] = 1;
      this.currentId = 1;
    } else {
      this.blockIdentifiers[blockType] += 1;
      this.currentId = this.blockIdentifiers[blockType];
    }
  }

  verifyLayoutStructure(layout) {
    const keys = Object.keys(layout);

    // todo: Add type recognition and invalidate layouts with `-list` or `slot-x` if they have children
    this.layoutMandatory.forEach(function(layoutKey) {
      if (keys.findIndex(function(key) { return key === layoutKey }) == -1) {
        return(false);
      }
    });

    return(true);
  }

  dataLoader(linearObject, object) {
    this._logger("BUILD_DATA_INJECTION", { field: linearObject, object });

    let lastHeight = false;
    let currentNode = null;

    let nextNode = linearObject.replace(/([a-z-_]+)(\.*)/, function(match, p1, p2) {
      currentNode = p1;

      if (match == p1) {
        lastHeight = true;
      }

      return("");
    });

    if (lastHeight && currentNode) {
      return(object[currentNode] == undefined ? null : object[currentNode]);
    }

    return(this.dataLoader(nextNode, object[currentNode]));
  }

  injectWidgetData(content) {
    return(content.replace(/(\$\{(.*?)\})/g, function(match, p1, p2) {
      void match, p1;
      const widgetData = this.dataLoader(p2, this.data);

      if (widgetData == null) {
        console.error(this.data);
        console.error(`Error: empty widget data returned for ${p2}`);

        return("");
      }

      return(widgetData);
    }.bind(this)));
  }

  injectBlock(slot) {
    let elements = [];

    slot = parseInt(slot) - 1;

    if (slot === NaN || this.cardBlocks.length <= slot) {
      return(elements);
    }

    this.cardBlocks[slot].domElement.forEach(function(child) {
      elements.push(child);
    }.bind(this));

    return(elements);
  }

  generateElementFromLayout(layout) {
    let htmlElement = document.createElement(layout.type);

    if (layout.attributes) {
      let attributes = Object.keys(layout.attributes);

      attributes.forEach(function(attribute) {
        if (attribute != "onclick") {
          htmlElement.setAttribute(attribute, this.injectWidgetData(layout.attributes[attribute]));
        }
      }.bind(this));
    }

    if (layout.content) {
      htmlElement.innerHTML = this.injectWidgetData(layout.content);
    }

    return(htmlElement);
  }

  createElement(layout, parent = null, settings = null) {
    if (!this.verifyLayoutStructure(layout)) {
      return null
    }

    if (settings) {
      this.data.settings = settings;
    }

    if (!parent) {
      parent = this.generateElementFromLayout(layout);

      if (layout.children) {
        layout.children.forEach(function(child) {
          this.createElement(child, parent);
        }.bind(this));
      }

      return(parent);
    }

    this._logger("BUILD_PARENT_CHECK", { parent });
    this._logger("BUILD_LAYOUT_DEPTH", { layout, settings });

    let definedType = layout.type.match(/([a-z]+)(-([a-z0-9-]+))?/);
    let layoutType =  definedType[1] ? definedType[1] : null;
    let layoutActionType = definedType[3] ? definedType[3] : null;
    let childParent = null;
    let elements = [];

    this._logger("BUILD_DEFINE_TYPE", { type: layout.type, definedType, layoutType, layoutActionType });

    switch(layoutType) {
      case "slot":
        this._logger("BUILD_DETECTED", { detected: "Slot" });
        elements = this.buildType === "EDITOR" ? this._loadEmptyBlock(layoutActionType) : this.injectBlock(layoutActionType);

        if (elements.length < 1) {
          this._invalidate("Invalid layout build. Empty block slots remaining.");
        }
        break;
      default:
        layout.type = definedType[1];

        switch(layoutActionType) {
          case "list":
            this._logger("BUILD_DETECTED", { detected: "Element-List" });

            if (this.data.settings.list.length === 0) {
              // Prevent empty list therefore layout build invalidation.
              elements.push(document.createElement('span'))
            } else {
              this.data.settings.list.forEach((listElement) => {
                this.data.settings["list-data"] = listElement;
                elements.push(this.generateElementFromLayout(layout));
              });
            }
            break;

          default:
            this._logger("BUILD_DETECTED", { detected: "Element" });
            childParent = this.generateElementFromLayout(layout);

            elements.push(childParent);
            break;
        }
        break;
    }

    elements.forEach(function(element) {
      if (element !== null) {
        parent.appendChild(element);
      }
    });

    if (layout.children) {
      layout.children.forEach(function(child) {
        this.createElement(child, childParent);
      }.bind(this));
    }

    return(parent);
  }

  // types: {
  //   blockLabel,
  //   blockType
  // }
  buildHtml(layout, settings = null, settings_format = null, types = null) {
    let data = {
      settings: settings,
      settings_format: settings_format,
      domElement: null
    }

    this._logger("BUILD_START", { types, settings })

    if (data.settings && types) {
      this.generateBlockId(types.blockLabel);
      data.settings = HtmlSettings.loadPreBuildSettings(types.blockLabel, data);
    }

    this._logger("BUILD_CARD_BEGIN");
    data.domElement = this.createElement(layout, null, data.settings);

    // If for some reason the build failed return null so this card will be ignored
    if (this.invalidBuild) {
      console.log(layout)
      console.log(settings)
      console.log(settings_format)
      console.log(types)
      console.error(this.invalidationMessage);
      this._logger("BUILD_END");
      return null;
    }

    // Generate each block an ID and load functions to run for initEventListeners
    if (data.settings && data.domElement && types) {
      data.domElement.setAttribute("id", types.blockLabel + '-' + this.currentId);
      this.postBuildIdQueue.push({
        type: types.blockLabel,
        id: types.blockLabel + '-' + this.currentId,
        settings: data.settings
      });
    }

    this._logger("BUILD_END", { domElement: data.domElement });

    return(data.domElement);
  }
});
